'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'forklift';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f47a';
var svgPathData = ['M32 216l0 140.1c15.2-12.6 34.7-20.1 56-20.1 45.9 0 83.6 35.1 87.6 80l64.7 0c4-44.9 41.7-80 87.6-80 8.3 0 16.4 1.2 24 3.3l0-51.3-144 0c-4.2 0-8.3-1.7-11.3-4.7L105.4 192 56 192c-13.3 0-24 10.7-24 24z', 'M480 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 448c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-432zM32 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM0 216L0 424c0 48.6 39.4 88 88 88 40.3 0 74.2-27.1 84.7-64l70.6 0c10.4 36.9 44.4 64 84.7 64 48.6 0 88-39.4 88-88 0-27.3-12.5-51.7-32-67.9l0-89.6c0-9.3-2-18.4-5.9-26.8l-83-179.8c-7.8-17-24.9-27.9-43.6-27.9L144 32c-26.5 0-48 21.5-48 48l0 80-40 0c-30.9 0-56 25.1-56 56zM352 339.3c-7.6-2.2-15.7-3.3-24-3.3-45.9 0-83.6 35.1-87.6 80l-64.7 0c-4-44.9-41.7-80-87.6-80-21.3 0-40.8 7.5-56 20.1L32 216c0-13.3 10.7-24 24-24l49.4 0 91.3 91.3c3 3 7.1 4.7 11.3 4.7l144 0 0 51.3zM350.2 256l-135.6 0-86.6-86.6 0-89.4c0-8.8 7.2-16 16-16l107.5 0c6.2 0 11.9 3.6 14.5 9.3l83 179.8c.4 .9 .8 1.9 1.2 2.9zM272 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faForklift = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;